import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import it from './locales/it.json';
import de from './locales/de.json';
import fr from './locales/fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      it: { translation: it },
      de: { translation: de },
      fr: { translation: fr },
    },
    fallbackLng: 'it', // Default to Italian for Salento-focused site
    supportedLngs: ['en', 'it', 'de', 'fr'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Priority order: first time uses browser language, then localStorage for returning users
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
      excludeCacheFor: ['cimode'], // Don't cache in development mode
      cookieMinutes: 10080, // 7 days
      cookieDomain: typeof window !== 'undefined' ? window.location.hostname : undefined,
    },
  });

export default i18n;
